import React, { Component } from "react";
import { connect } from "react-redux";

import { Spin } from "antd";

import { loadLocations } from "../../store/actions/locationAction";
import { loadQuittances } from "../../store/actions/quittanceAction";
import { loadComptes } from "../../store/actions/compteAction";
import { loadReglements, updateReglement } from "../../store/actions/reglementAction";
import { saveEcriture } from "../../store/actions/ecritureAction";

import TableValidationBordereau from "../../components/TableValidationBordereau";

class ValidationBordereau extends Component {
  componentDidMount() {
    Promise.all([
      !this.props.quittances && this.props.loadQuittances(),
      !this.props.reglements && this.props.loadReglements(),
      !this.props.comptes && this.props.loadComptes(),
      !this.props.locations && this.props.loadLocations(),
    ]);
  }

  render() {
    const {
      societes,
      journals,
      comptes,
      locations,
      quittances,
      reglements,
      typesPaiements
    } = this.props;

    return (
      <Spin
        size="large"
        tip="Chargement en cours..."
        spinning={!comptes || !locations || !quittances || !reglements}
      >
        <TableValidationBordereau
          societes={societes}
          journals={journals}
          comptes={comptes}
          locations={locations}
          quittances={quittances}
          reglements={reglements?.filter((item) => item.reglement_bordereau === true)}
          typesPaiements={typesPaiements.filter((item) => item.type_paiement_bordereau)}
          updateReglement={this.props.updateReglement}
          saveEcriture={this.props.saveEcriture}
        />
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadComptes: () => dispatch(loadComptes()),
    loadLocations: () => dispatch(loadLocations()),
    loadQuittances: () => dispatch(loadQuittances()),
    loadReglements: () => dispatch(loadReglements()),
    updateReglement: (jsonData, id) => dispatch(updateReglement(jsonData, id)),
    saveEcriture: (ecriture) => dispatch(saveEcriture(ecriture)),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    societes: state.societes.data,
    journals: state.journals.data,
    comptes: state.comptes.data,
    locations: state.locations.data,
    quittances: state.quittances.data,
    reglements: state.reglements.data,
    typesPaiements: state.typesPaiements.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ValidationBordereau);
